import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { NotifyPopupService, PopupKey } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { User, UserInfo } from '@/services/user'
import UpdatePassword from '@/views/dashboard/_components/update-password/update-password.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'update-password',
  setup(__props) {

const injector = useReflectiveInjector([])
const user = injector.get(User)
const notifyPopupService = injector.get(NotifyPopupService)

const userInfo = reactive<Partial<UserInfo>>({})
user.userInfo.subscribe(info => { Object.assign(userInfo, info) })

const updatePasswordVisible = ref(false)

const notifyPopupSubscribe = notifyPopupService.onChangeActiveIndex.subscribe(() => {
  const popupKey = notifyPopupService.activePopupKey
  if (popupKey !== PopupKey.updatePassword) {
    return
  }

  if (userInfo.need_update_pwd) {
    updatePasswordVisible.value = true
  } else {
    notifyPopupService.nextPopup()
  }
})
const onFinish = () => {
  updatePasswordVisible.value = false
  notifyPopupService.closeAllPopup
}

onMounted(() => {
  notifyPopupService.popupToReady(PopupKey.updatePassword)
})

onUnmounted(() => {
  notifyPopupSubscribe.unsubscribe()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UpdatePassword, {
    modelValue: updatePasswordVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updatePasswordVisible).value = $event)),
    onSubmit: onFinish
  }, null, 8, ["modelValue"]))
}
}

})